import { IClassname } from '@/lib/shared/model/classname';

export const Restaurant = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.30396 10.2495L2.58187 21.7508L1.30396 29.4183"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.58179 21.7505H7.69345C8.03238 21.7505 8.35742 21.8851 8.59708 22.1248C8.83673 22.3644 8.97137 22.6895 8.97137 23.0284V29.418"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6961 10.2495L29.4182 21.7508L30.6961 29.4183"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.4181 21.7505H24.3065C23.9676 21.7505 23.6425 21.8851 23.4029 22.1248C23.1632 22.3644 23.0286 22.6895 23.0286 23.0284V29.418"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41553 15.3608H25.5843"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 15.3608V26.8621"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4025 29.4181C19.9592 28.6418 19.3185 27.9964 18.5454 27.5476C17.7722 27.0987 16.8941 26.8623 16.0001 26.8623C15.1061 26.8623 14.228 27.0987 13.4548 27.5476C12.6816 27.9964 12.0409 28.6418 11.5977 29.4181"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0831 7.69336C14.1583 8.45409 13.933 9.21405 13.4555 9.81097C12.9779 10.4079 12.286 10.7945 11.5273 10.8882C10.7686 10.7945 10.0767 10.4079 9.59912 9.81097C9.12158 9.21405 8.89633 8.45409 8.97147 7.69336H14.0831Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5273 10.8882V15.3609"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0287 15.3612H17.917V8.84382C17.9174 8.09334 18.1397 7.35974 18.556 6.73526C18.9722 6.11078 19.1945 5.37718 19.1949 4.6267V3.22099C19.1949 3.05153 19.2622 2.88901 19.3821 2.76918C19.5019 2.64935 19.6644 2.58203 19.8339 2.58203H21.1118C21.2812 2.58203 21.4438 2.64935 21.5636 2.76918C21.6834 2.88901 21.7507 3.05153 21.7507 3.22099V4.6267C21.7512 5.37718 21.9735 6.11078 22.3897 6.73526C22.8059 7.35974 23.0282 8.09334 23.0287 8.84382V15.3612Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
